import { FC } from 'react'
import cx from 'classnames'
import ReactMarkdown from 'react-markdown'

import { Icons } from '../Icon'
import { FormSubmitButtonProps } from '../../form/FormSubmitButton'

import * as SC from './styled'

export type BannerOfferProps = {
  className?: string
  dateLabel?: string
  date?: string
  goalsLabel?: string
  goals?: string
  priceLabel?: string
  price?: string
  priceExposant?: string
  publicPriceLabel?: string
  publicPrice?: string
  discount?: string
  discountLabel?: string
  discountLegend?: string
  discoverOfferLabel?: string
  titleNotConnected?: string
  textNotConnected?: string
  textBlockRight?: string
  voucherCode?: string
  button?: FormSubmitButtonProps
}

const BannerOffer: FC<BannerOfferProps> = ({
  className,
  dateLabel,
  date,
  goalsLabel,
  goals,
  priceLabel,
  price,
  priceExposant,
  publicPriceLabel,
  publicPrice,
  discount,
  discountLabel,
  discountLegend,
  discoverOfferLabel,
  titleNotConnected,
  textNotConnected,
  textBlockRight,
  voucherCode,
  button,
}) => {
  return (
    <>
      <SC.Banner className={cx('BannerOffer', className)}>
        <SC.BannerWrapper>
          <SC.BannerLeftBlock $titleNotConnected={titleNotConnected}>
            {discoverOfferLabel ? (
              <SC.DiscoverOfferBlock>
                <SC.ImageIcon icon={Icons.ArrowsBottomMulti} />
                <SC.DiscoverOfferLabel>
                  {discoverOfferLabel}
                </SC.DiscoverOfferLabel>
              </SC.DiscoverOfferBlock>
            ) : titleNotConnected ? (
              <>
                <SC.TitleNotConnected>{titleNotConnected}</SC.TitleNotConnected>
                <SC.TextNotConnected>{textNotConnected}</SC.TextNotConnected>
              </>
            ) : (
              <>
                <SC.BannerLeftBlockLeftSide>
                  {dateLabel && <SC.DateLabel>{dateLabel}</SC.DateLabel>}
                  {date && <SC.Date>{date}</SC.Date>}
                  {priceLabel && <SC.PriceLabel>{priceLabel}</SC.PriceLabel>}
                  {(price || priceExposant) && (
                    <SC.PriceBlock>
                      {price && (
                        <SC.Price data-prefix={priceExposant}>{price}</SC.Price>
                      )}
                    </SC.PriceBlock>
                  )}
                </SC.BannerLeftBlockLeftSide>
                {!titleNotConnected && <SC.Divider />}
                <SC.BannerLeftBlockRightSide>
                  {goalsLabel && <SC.GoalsLabel>{goalsLabel}</SC.GoalsLabel>}
                  {goals && (
                    <SC.Goals>
                      <ReactMarkdown>{goals}</ReactMarkdown>
                    </SC.Goals>
                  )}
                  {publicPriceLabel && (
                    <SC.PublicPriceLabel>
                      {publicPriceLabel}
                    </SC.PublicPriceLabel>
                  )}
                  {discountLabel && (
                    <SC.DiscountLabel>{discountLabel}</SC.DiscountLabel>
                  )}

                  {publicPrice && discount && (
                    <SC.PublicPriceBlock>
                      {publicPrice && (
                        <SC.PublicPrice>
                          <s>{publicPrice}</s>
                        </SC.PublicPrice>
                      )}
                      {discount && <SC.Discount>{discount}</SC.Discount>}
                    </SC.PublicPriceBlock>
                  )}

                  {discountLegend && discount && (
                    <SC.DiscountLegend>
                      {discountLegend}
                      <SC.Discount> {discount}</SC.Discount>
                    </SC.DiscountLegend>
                  )}
                </SC.BannerLeftBlockRightSide>
              </>
            )}
          </SC.BannerLeftBlock>

          {(textBlockRight || voucherCode || button) && (
            <SC.BannerRightBlock>
              {textBlockRight && (
                <SC.TextBlockRight>{textBlockRight}</SC.TextBlockRight>
              )}
              {voucherCode && <SC.VoucherCode>{voucherCode}</SC.VoucherCode>}
              {button && <SC.Button {...button} />}
            </SC.BannerRightBlock>
          )}
        </SC.BannerWrapper>
      </SC.Banner>
    </>
  )
}

export default BannerOffer
